@if (!!fieldData) {
  <ziro-natural-language-editor
    [entity]="fieldData"
    [dataAutomation]="'call-record-query-field'"
    [entityValidators]="nleEntityValidators"
    (entityUpdate)="updateSelf($event, true, fieldData)"
    (validationUpdate)="updateValidationState($event)"
  >
    <span [innerHTML]="'tkey;reports.pstn_call_record_finder.editor.calls_1' | escapeHtml"></span>
    <ziro-natural-language-editor-single
      [options]="callDirectionOptions"
      [phraseId]="'callDirectionType'"
    ></ziro-natural-language-editor-single>
    <span>{{ 'tkey;reports.pstn_call_record_finder.query.text.call_from' | translate }}</span>
    <ziro-natural-language-editor-double
      [options]="callRecordSearchTypeOptions"
      [primaryDropdownLabel]="
        'tkey;reports.microsoft.pstn_call_record_finder.query.call_direction.type.search_from.label'
      "
      [phraseId]="'searchValue'"
    ></ziro-natural-language-editor-double>
    <span>
      {{
        'tkey;reports.microsoft.pstn_call_record_finder.query.call_direction.type.search_date_between.label' | translate
      }}
    </span>
    <ziro-natural-language-editor-datepicker
      [phraseId]="'fromDate'"
      [minDate]="minDate"
      [disabledDateTooltipText]="disabledDateTooltipText()"
      [externalHasValidationError]="dateRangeInvalid"
    ></ziro-natural-language-editor-datepicker>
    <span>
      {{ 'tkey;reports.microsoft.pstn_call_record_finder.query.call_direction.type.search_date_and.label' | translate }}
    </span>
    <ziro-natural-language-editor-datepicker
      [phraseId]="'toDate'"
      [minDate]="minDate"
      [disabledDateTooltipText]="disabledDateTooltipText()"
      [externalHasValidationError]="dateRangeInvalid"
    ></ziro-natural-language-editor-datepicker>
  </ziro-natural-language-editor>
}
